import {useMutation} from '@tanstack/react-query';
import proposalUpdaters from '@/api/updaters/proposals';

function useAcceptProposal() {
  return useMutation({
    mutationKey: ['proposals', 'accept'],
    mutationFn: proposalUpdaters.accept,
  });
}

export default useAcceptProposal;
